import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAppState } from 'hooks/useAppState';
import { useAsyncProcess } from 'hooks/useAsyncProcess';

export const useDemoStackURLProcess = () => {
  const { demoStackUrl } = useAppState();

  const startProcess = useAsyncProcess();

  const dispatch = useAppDispatcher();

  React.useLayoutEffect(() => {
    if (demoStackUrl === undefined) {
      startProcess((services) =>
        services.getDemoStackUrl().then((demoStackUrl) => {
          dispatch({
            name: 'DemoStackURLResolved',
            demoStackUrl,
          });
        })
      );
    }
  }, [demoStackUrl, dispatch, startProcess]);
};
